import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    claimButton: {
      intercomMessage: 'Hello, I would like to report an accident\n',
    },
    content: {
      exclude: {
        items: [
          'Transactions made following intentional fault or negligence on your part or by one of your relatives;',
          'Fraudulent transactions committed before the loss or theft;',
          'If the card has not been blocked.',
        ],
        title: 'This warranty does not include',
      },
      include: {
        items: [
          'Reimbursement of losses not covered by Shine and remaining at your expense in the event of fraudulent payment or withdrawal transactions following the loss or theft of your payment methods;',
          'Up to a limit of {0} € per year, per beneficiary.',
        ],
        title: 'This warranty includes',
      },
      warning: {
        description:
          'You must take all necessary measures to ensure the security of your payment and/or withdrawal methods, particularly your mobile phone, cards, and PIN code. Keep your PIN codes absolutely secret, do not share them with anyone, and do not write them on your cards or any other document.',
        title: 'Warning',
      },
    },
    similarOffersTitle: 'Related insurances',
    title: 'Payment Fraud',
  },
  fr: {
    claimButton: {
      intercomMessage: 'Bonjour, je souhaiterais déclarer un accident\n',
    },
    content: {
      exclude: {
        items: [
          'Les transactions ayant été réalisées suite à une faute intentionnelle ou à une négligence de votre part ou d’un de vos proches ;',
          'Les opérations frauduleuses commises avant la perte ou le vol ;',
          'Si la carte n’a pas été mise en opposition.',
        ],
        title: 'Cette garantie n’inclut pas',
      },
      include: {
        items: [
          'Le remboursement des pertes non couvertes par Shine et restées à votre charge en cas d’opérations de paiement ou de retrait frauduleux suite à la perte ou au vol de vos moyens de paiements ;',
          'Dans la limite de {0} € par an, par bénéficiaire.',
        ],
        title: 'Cette garantie inclut',
      },
      warning: {
        description:
          'Vous devez prendre toutes les mesures propres à assurer la sécurité de vos Moyens de paiement et/ou de retrait et notamment de votre téléphone mobile, de vos cartes et de votre code confidentiel, tenir ses codes confidentiels absolument secrets, ne les communiquer à qui que ce soit et notamment ne pas les inscrire sur vos cartes ou sur un autre document.',
        title: 'Attention',
      },
    },

    similarOffersTitle: 'Autres assurances liées',
    title: 'Fraude au moyen de paiement',
  },
} as const);

export default locales;
